import "~/app/publicPath";
// =========================
// Polyfill's
// =========================

import "custom-event-polyfill";

// =========================
// Framework's
// =========================

import Vue from "vue";
import Vuex from "vuex";
import {mount} from "ceres/mount";

Vue.prototype.$mount = mount;

window.Vue = Vue;
window.Vuex = Vuex;

import script2 from "ceres/app/plugins/script2";
Vue.use(script2);
import PortalVue from "portal-vue";
Vue.use(PortalVue);

import "ceres/app/jQuery";

import "bootstrap";
import "owl.carousel";
import {Navigation, Pagination, Autoplay, Swiper, Scrollbar} from "swiper";
Swiper.use([Navigation, Pagination, Autoplay, Scrollbar]);

import {getUrlParams} from "ceres/app/services/UrlService";
window.ceresEnv = getUrlParams()["env"];

// =========================
// COMPONENTS
// =========================
// Vue.component("add-item-to-basket-overlay", () => import("~/app/components/basket/AddItemToBasketOverlay.vue"));

Vue.component("add-to-basket", () =>
    import("~/app/components/basket/AddToBasket.vue")
);
Vue.component("basket-preview", () =>
    import("~/app/components/basket/BasketPreview.vue")
);
Vue.component("basket-totals", () =>
    import("ceres/app/components/basket/BasketTotals.vue")
);
Vue.component("mail-changed-info", () =>
    import("ceres/app/components/basket/MailChangedInfo.vue")
);
Vue.component("coupon", () => import("ceres/app/components/basket/Coupon.vue"));
Vue.component("basket-list", () =>
    import("~/app/components/basket/list/BasketList.vue")
);

// Vue.component("step-by-step-navigation", () => import("ceres/app/components/category/StepByStepNavigation.vue"));
// Vue.component("google-maps-widget", () => import("ceres/app/components/common/GoogleMaps.vue"));
import LazyImg from "~/app/components/common/LazyImg.vue";
Vue.component("lazy-img", LazyImg);
import Intersect from "ceres/app/components/common/Intersect.vue";
Vue.component("intersect", Intersect);
import TabList from "ceres/app/components/common/TabList.vue";
Vue.component("tab-list", TabList);
import TabItem from "ceres/app/components/common/TabItem.vue";
Vue.component("tab-item", TabItem);
// Vue.component("last-seen-item-list", () => import("ceres/app/components/containers/LastSeenItemList.vue"));

Vue.component("change-email-form", () =>
    import("ceres/app/components/customer/ChangeEmailForm.vue")
);
import ReCaptcha from "~/app/components/customer/ReCaptcha.vue";
Vue.component("recaptcha", ReCaptcha);
Vue.component("registration", () =>
    import("~/app/components/customer/Registration.vue")
);
Vue.component("reset-password-form", () =>
    import("ceres/app/components/customer/ResetPasswordForm.vue")
);
Vue.component("forgot-password-modal", () =>
    import("ceres/app/components/customer/login/ForgotPassword.vue")
);
Vue.component("guest-login", () =>
    import("~/app/components/customer/login/GuestLogin.vue")
);
Vue.component("login", () =>
    import("~/app/components/customer/login/Login.vue")
);
// legacy non-shopbuilder component
Vue.component("login-view", () =>
    import("~/app/components/customer/login/LoginView.vue")
);
import UserLoginHandler from "~/app/components/customer/login/UserLoginHandler.vue";
Vue.component("user-login-handler", UserLoginHandler);
// Vue.component("form-attachment", () => import("ceres/app/components/form/FormAttachment.vue"));

Vue.component("item-bundle", () =>
    import("ceres/app/components/item/ItemBundle.vue")
);
// Vue.component("order-property-value", () => import("ceres/app/components/item/OrderPropertyValue.vue"));
Vue.component("quantity-input", () =>
    import("ceres/app/components/item/QuantityInput.vue")
);

Vue.component("tag-list", () =>
    import("ceres/app/components/item/TagList.vue")
);

Vue.component("category-item", () =>
    import("~/app/components/itemList/CategoryItem.vue")
);

import ItemSearch from "~/app/components/itemList/ItemSearch.vue";
Vue.component("item-search", ItemSearch);
Vue.component("item-search-result", () =>
    import("~/app/components/itemList/ItemSearchResult.vue")
);

Vue.component("item-filter-list", () =>
    import("~/app/components/itemList/filter/ItemFilterList.vue")
);
Vue.component("item-filter-tag-list", () =>
    import("~/app/components/itemList/filter/ItemFilterTagList.vue")
);
Vue.component("item-filter-list-mobile", () =>
    import("~/app/components/itemList/filter/ItemFilterListMobile.vue")
);

// Vue.component("live-shopping-item", () => import("ceres/app/components/liveShopping/LiveShoppingItem.vue"));

// Vue.component("newsletter-input", () => import("ceres/app/components/newsletter/NewsletterInput.vue"));
// Vue.component("newsletter-unsubscribe-input", () => import("ceres/app/components/newsletter/NewsletterUnsubscribeInput.vue"));

Vue.component("order-return", () =>
    import("ceres/app/components/orderReturn/OrderReturn.vue")
);

Vue.component("cookie-bar", () =>
    import("~/app/components/pageDesign/CookieBar.vue")
);
Vue.component("privacy-settings", () =>
    import("ceres/app/components/pageDesign/PrivacySettings.vue")
);
Vue.component("carousel", () =>
    import("~/app/components/pageDesign/Carousel.vue")
);
import Icon from "ceres/app/components/pageDesign/Icon.vue";
Vue.component("icon", Icon);
// import LanguageDetection from "ceres/app/components/pageDesign/LanguageDetection.vue";
// Vue.component("language-detection", LanguageDetection);
import MobileNavigation from "~/app/components/pageDesign/MobileNavigation.vue";
Vue.component("mobile-navigation", MobileNavigation);
import Notifications from "ceres/app/components/pageDesign/Notifications.vue";
Vue.component("notifications", Notifications);
Vue.component("popper", () => import("~/app/components/pageDesign/Popper.vue"));
Vue.component("shipping-country-select", () =>
    import("~/app/components/pageDesign/ShippingCountrySelect.vue")
);
Vue.component("shipping-country-short-name", () =>
    import("~/app/components/pageDesign/ShippingCountryShortName.vue")
);
Vue.component("loading-animation", () =>
    import("ceres/app/components/pageDesign/LoadingAnimation.vue")
);

Vue.component("wish-list", () =>
    import("~/app/components/wishList/WishList.vue")
);
import WishListCount from "~/app/components/wishList/WishListCount.vue";
Vue.component("wish-list-count", WishListCount);

import LazyLoad from "ceres/app/components/common/LazyLoad.vue";
Vue.component("lazy-load", LazyLoad);

Vue.component("add-to-wish-list", () =>
    import("~/app/components/item/AddToWishList.vue")
);
Vue.component("graduated-prices", () =>
    import("~/app/components/item/GraduatedPrices.vue")
);
// Vue.component("item-data-table", () => import("ceres/app/components/item/ItemDataTable.vue"));
Vue.component("item-image-carousel", () =>
    import("~/app/components/item/ItemImageCarousel.vue")
);
Vue.component("item-price", () =>
    import("~/app/components/item/ItemPrice.vue")
);
// Vue.component("set-price", () => import("ceres/app/components/item/SetPrice.vue"));
// Vue.component("order-property-list", () => import("ceres/app/components/item/OrderPropertyList.vue"));
Vue.component("variation-select", () =>
    import("~/app/components/item/VariationSelect.vue")
);
Vue.component("item-availability", () =>
    import("~/app/components/item/ItemAvailability.vue")
);
Vue.component("single-item-bundle", () =>
    import("ceres/app/components/item/SingleItemBundle.vue")
);
Vue.component("item-manufacturer", () =>
    import("ceres/app/components/item/ItemManufacturer.vue")
);
Vue.component("item-manufacturer-data-list", () =>
    import("ceres/app/components/item/ItemManufacturerDataList.vue")
);
Vue.component("item-eu-responsible-data-list", () =>
    import("ceres/app/components/item/ItemEuResponsibleDataList.vue")
);
Vue.component("manufacturer-details", () =>
    import("ceres/app/components/item/ManufacturerDetails.vue")
);
Vue.component("eu-responsible-details", () =>
    import("ceres/app/components/item/EuResponsibleDetails.vue")
);
Vue.component("single-add-to-basket", () =>
    import("ceres/app/components/item/SingleAddToBasket.vue")
);
// Vue.component("set-quantity-input", () => import("ceres/app/components/item/SetQuantityInput.vue"));
import SingleItem from "~/app/components/item/SingleItem.vue";
Vue.component("single-item", SingleItem);
// import SingleItemSetComponent from "ceres/app/components/item/SingleItemSetComponent.vue";
// Vue.component("single-item-set-component", SingleItemSetComponent);

import LazyHydrate from "vue-lazy-hydration";
Vue.component("lazy-hydrate", LazyHydrate);
import ClientOnly from "ceres/app/components/common/ClientOnly.vue";
Vue.component("client-only", ClientOnly);
import BackgroundImg from "ceres/app/components/common/BackgroundImg.vue";
Vue.component("background-img", BackgroundImg);

// =========================
// DIA COMPONENTS
// =========================
Vue.component("accordion-widget", () =>
    import("~/app/components/widgets/grid/AccordionWidget.vue")
);
import PortalMobile from "./app/components/common/PortalMobile.vue";
Vue.component("portal-mobile", PortalMobile);
import LayoutSwitch from "./app/components/category/LayoutSwitch.vue";
Vue.component("layout-switch", LayoutSwitch);
import ShowNetPriceSwitch from "./app/components/pageDesign/ShowNetPriceSwitch.vue";
Vue.component("show-net-price-switch", ShowNetPriceSwitch);
import DetectCustomerTypeCountry from "./app/components/pageDesign/DetectCustomerTypeCountry.vue";
Vue.component("detect-customer-type-country", DetectCustomerTypeCountry);
import UkModal from "./app/components/pageDesign/UkModal.vue";
Vue.component("uk-modal", UkModal);
import OdPortalTarget from "~/app/components/common/OdPortalTarget.vue";
Vue.component("od-portal-target", OdPortalTarget);

Vue.component("empty-item-list", () =>
    import("./app/components/category/EmptyItemList.vue")
);
Vue.component("load-more-items", () =>
    import("~/app/components/category/LoadMoreItems.vue")
);
Vue.component("category-level-four", () =>
    import("~/app/components/category/CategoryLevelFour.vue")
);
Vue.component("category-add-wishlist", () =>
    import("./app/components/itemList/AddToWishList.vue")
);
Vue.component("od-feedback-average", () =>
    import("./app/components/item/ODFeedbackAverage.vue")
);
Vue.component("free-shipping-hint", () =>
    import("./app/components/basket/FreeShippingHint.vue")
);
Vue.component("request-offer", () =>
    import("./app/components/basket/RequestOffer.vue")
);
Vue.component("replacement-part-finder", () =>
    import("./app/components/common/ReplacementPartFinder.vue")
);
Vue.component("youtube-modal", () =>
    import("./app/components/item/YoutubeModal.vue")
);
Vue.component("od-portal-target", () =>
    import("~/app/components/common/OdPortalTarget.vue")
);
Vue.component("price-switch", () =>
    import("~/app/components/customer/PriceSwitch.vue")
);
Vue.component("crossselling-basket", () =>
    import("~/app/components/item/CrosssellingBasket.vue")
);
Vue.component("language-switch", () =>
    import("~/app/components/pageDesign/LanguageSwitch.vue")
);
Vue.component("vue-lazy-loader", () =>
    import("~/app/components/common/VueLazyLoader.vue")
);
Vue.component("image-carousel", () =>
    import("~/app/components/widgets/common/ImageCarousel.vue")
);

// =========================
// DIRECTIVES
// =========================
import "~/app/directives/basket/basketItemQuantity";
import "ceres/app/directives/basket/basketItemSum";
import "ceres/app/directives/basket/toggleBasketPreview";

import "ceres/app/directives/category/openFilterToolbar";

import "ceres/app/directives/common/truncateTooltip";

import "ceres/app/directives/customer/logout";

import "ceres/app/directives/helper/testingAttr";
import "ceres/app/directives/helper/populateStore";
import "ceres/app/directives/helper/validate";
import "ceres/app/directives/helper/waitingAnimation";
import "ceres/app/directives/helper/waitingAnimationInfinite";

import "ceres/app/directives/navigation/navigationTouchHandler";
import "ceres/app/directives/navigation/openMobileNavigation";

import "ceres/app/directives/pageDesign/scrollToTop";
import "~/app/directives/pageDesign/stickInParent";
import "ceres/app/directives/navigation/sidenavigationChildrenLoader";
import "ceres/app/directives/pageDesign/tooltip";

// =========================
// DIA DIRECTIVES
// =========================
import "~/app/directives/navigation/openMobileFilter";

// =========================
// FILTERS
// =========================
import "ceres/app/filters/ageRestriction.filter";
import "ceres/app/filters/arrayFirst.filter";
import "ceres/app/filters/attachText.filter";
import "~/app/filters/currency.filter";
import "~/app/filters/currencyPlenty.filter";
import "ceres/app/filters/date.filter";
import "ceres/app/filters/fileName.filter";
import "ceres/app/filters/fileUploadPath.filter";
import "ceres/app/filters/graduatedPrice.filter";
import "ceres/app/filters/hasItemDefaultPrice.filter";
import "ceres/app/filters/inputUnit.filter";
import "ceres/app/filters/itemBundleName.filter";
import "ceres/app/filters/itemCrossPrice.filter";
import "ceres/app/filters/itemImage.filter";
import "ceres/app/filters/itemImageHeight.filter";
import "ceres/app/filters/itemImageWidth.filter";
import "ceres/app/filters/itemImageAlternativeText.filter";
import "ceres/app/filters/itemImages.filter";
import "ceres/app/filters/itemName.filter";
import "ceres/app/filters/itemPrice.filter";
import "ceres/app/filters/itemUrl.filter";
import "ceres/app/filters/numberFormat.filter";
// import "~/app/filters/propertySurcharge.filter";
import "ceres/app/filters/propertyFileUrl.filter";
import "ceres/app/filters/translate.filter";
import "ceres/app/filters/truncate.filter";

// =========================
// MIXINS
// =========================
import "ceres/app/mixins/getJsonData.mixin";
import "ceres/app/mixins/template.mixin";

// =========================
// Bootstrap frameworks
// =========================
import "./app/main";

import TranslationService from "ceres/app/services/TranslationService";
import {
    createStore,
    initClientListeners,
    initClientStore,
    initServerStore,
} from "./app/store";
import {initListener} from "ceres/app/services/ApiService";

window.ceresTranslate = TranslationService.translate;

Vue.prototype.$translate = TranslationService.translate;
Vue.prototype.$ceres = App;

const store = createStore();

window.ceresStore = store;

initServerStore(store);
initClientStore(store);
initClientListeners(store);
initListener();
